
import { trackLoginImpression, trackRegTrigger } from "@/plugins/hwtag/events";
export default {
  name: "AuthFooter",
  data() {
    return {
      isGoogleInit: false,
      isAppleInit: false,
      appleLoading: false,
      isScrollHidden: false,
      lastScrollTop: 0,
      accumulatedScroll: 0,
      scrollThreshold: 40,
      scrollTimer: null,
      ticking: false,
      googleClickTracked: false,
      googleClickResetTimer: null,
    };
  },
  props: {
    visible: {
      type: Boolean,
      default: true,
    },
  },
  methods: {
    openLoginModal() {
      this.$emit("open-login", {
        source: { elementTypeName: '底部浮窗栏', clickName: 'Sign up' },
      });
    },
    handleGoogleClick() {
      trackRegTrigger('点击', '底部浮窗栏', 'Google');
    },
    detectGoogleIframeClick() {
      // Google 官方按钮是 iframe，点击事件不会冒泡到父级 div，
      // 通过监听 window blur + activeElement 是否落在 #g_id_onload_footer 内来识别点击
      // 注意: 一次点击会触发多次 blur (点击 iframe + 之后 Google 打开 OAuth popup),
      // 用同步锁 + 时间窗口去重, 不依赖 focus 事件 (focus 在不同浏览器下行为不可靠)
      if (this.googleClickTracked) return;
      this.googleClickTracked = true;
      setTimeout(() => {
        const active = document.activeElement;
        const hit =
          active &&
          active.tagName === 'IFRAME' &&
          active.closest &&
          active.closest('#g_id_onload_footer');
        if (hit) {
          this.handleGoogleClick();
          // 锁定一段时间后自动解锁, 避免一次点击触发多次 blur 重复上报
          // 同时保证后续真实的再次点击能正常上报
          if (this.googleClickResetTimer) clearTimeout(this.googleClickResetTimer);
          this.googleClickResetTimer = setTimeout(() => {
            this.googleClickTracked = false;
            this.googleClickResetTimer = null;
          }, 1500);
        } else {
          // 误判: 失焦不是因为 Google iframe, 立即回滚锁
          this.googleClickTracked = false;
        }
      }, 0);
    },
    openRegisterModal() {
      trackRegTrigger('点击', '底部浮窗栏', 'Sign up');
      this.$emit("open-register");
    },
    closeFooter() {
      this.$emit("update:visible", false);
    },
    async initGoogleBtn() {
      if (this.isGoogleInit) return;
      if (!this.$googleSignin) return;
      const el = document.getElementById("g_id_onload_footer");
      if (!el) return;
      await this.$googleSignin.init(this.handleGoogleLogin);
      this.$googleSignin.renderButton("g_id_onload_footer", {
        theme: "outline",
        size: "large",
        type: "icon",
      });
      this.isGoogleInit = true;
    },
    async initAppleBtn() {
      if (this.isAppleInit) return;
      if (!this.$appleSignin) return;
      try {
        await this.$appleSignin.init({
          redirectURI: window.location.origin,
        });
        this.isAppleInit = true;
      } catch (error) {
        console.error("Apple SignIn init error:", error);
      }
    },
    async handleAppleLogin() {
      trackRegTrigger('点击', '底部浮窗栏', 'Apple');
      if (this.appleLoading) return;
      if (!this.$appleSignin) return;

      this.appleLoading = true;
      try {
        if (!this.isAppleInit) {
          await this.initAppleBtn();
        }

        const appleAuth = await this.$appleSignin.login();
        console.log(appleAuth, "appleAuth");

        if (!appleAuth) {
          this.$message.error(this.$t('page.APPLE_LOGIN_FAILED'));
          return;
        }

        const res = await this.$global.thirdPartyLogin(
          {
            third_party_token: appleAuth.code,
            third_party_type: "8", // ios主体变更改为8
          },
          {
            jumpUrl: window.location.origin + "/user/gallery",
            lang: this.$i18n.locale || "en",
          }
        );

        if (res.code == 1) {
          this.$message.success(this.$t('page.LOGIN_SUCCESS'));
          this.$store.commit("SETTOKEN", res.data);
          const result = await this.$global.xfansLogin(res.data);
          this.$cookies.set("SSOTOKEN", res.data.token, {
            maxAge: 60 * 60 * 24 * 7,
          });
          this.$cookies.set("lastVerifiedTime", new Date().getTime());

          if (result.code == 1) {
            this.$store.commit("USER_INFO", result.data);
            this.$store.commit("ISLOGIN", true);
            this.$store.state.report = false;
            localStorage.setItem("storeState", JSON.stringify(this.$store.state));
            this.closeFooter();
            this.$router.push("/user/gallery");
          } else {
            this.$store.commit("SIGNOUT");
            this.$message.warning(this.$t('page.ACCOUNT_RESTRICTED'));
          }
        } else {
          this.$store.commit("SIGNOUT");
          this.$message.error(res?.msg || this.$t('page.APPLE_LOGIN_FAILED'));
        }
      } catch (error) {
        console.error("Apple login error:", error);
        this.$message.error(error?.message || this.$t('page.APPLE_LOGIN_FAILED'));
      } finally {
        this.appleLoading = false;
      }
    },
    async handleGoogleLogin(response) {
      
      console.log("Google 登录成功，Token:", response);
      this.$global
        .thirdPartyLogin(
          {
            third_party_token: response.credential,
            third_party_type: "3",
            google_web_push: ["user","fedcm"].includes(response.select_by)?'1':'0'
          },
          {
            jumpUrl: window.location.origin + "/user/gallery",
            lang: this.$i18n.locale || "en",
          }
        )
        .then(async (res) => {
          if (res.code == 1) {
            this.$message.success(this.$t('page.LOGIN_SUCCESS'));
            this.$store.commit("SETTOKEN", res.data);
            const result = await this.$global.xfansLogin(res.data);
            this.$cookies.set("SSOTOKEN", res.data.token, {
              maxAge: 60 * 60 * 24 * 7,
            });
            this.$cookies.set("lastVerifiedTime", new Date().getTime());
            result.code == 1
              ? (this.$store.commit("USER_INFO", result.data),
                this.$store.commit("ISLOGIN", true))
              : (this.$store.commit("SIGNOUT"),
                (this.disableUserDialogVisible = true),
                this.signOut());
            this.$store.state.report = false;
            localStorage.setItem("storeState", JSON.stringify(this.$store.state));
          } else {
            this.$store.commit("SIGNOUT");
          }
        });
      this.closeFooter();
    },
    addScrollListener() {
      window.addEventListener("scroll", this.handleScroll, { passive: true });
    },
    removeScrollListener() {
      window.removeEventListener("scroll", this.handleScroll, { passive: true });
      if (this.scrollTimer) {
        clearTimeout(this.scrollTimer);
        this.scrollTimer = null;
      }
    },
    addGoogleClickListener() {
      window.addEventListener("blur", this.detectGoogleIframeClick);
    },
    removeGoogleClickListener() {
      window.removeEventListener("blur", this.detectGoogleIframeClick);
      if (this.googleClickResetTimer) {
        clearTimeout(this.googleClickResetTimer);
        this.googleClickResetTimer = null;
      }
    },
    handleScroll() {
      if (this.ticking) return;
      this.ticking = true;
      requestAnimationFrame(() => {
        const currentScrollTop = Math.max(
          0,
          window.pageYOffset || document.documentElement.scrollTop || 0
        );
        const delta = currentScrollTop - this.lastScrollTop;
        const distance = Math.abs(delta);
        if (distance > 0) {
          this.accumulatedScroll += distance;
          if (this.accumulatedScroll > this.scrollThreshold) {
            this.isScrollHidden = true;
          }
        }
        this.lastScrollTop = currentScrollTop;
        this.ticking = false;
      });

      if (this.scrollTimer) clearTimeout(this.scrollTimer);
      this.scrollTimer = setTimeout(() => {
        this.isScrollHidden = false;
        this.accumulatedScroll = 0;
      }, 1500);
    },
  },
  watch: {
    visible(val) {
      if (!val) {
        this.isGoogleInit = false;
        this.isAppleInit = false;
      } else {
        this.$nextTick(() => {
          this.initGoogleBtn();
          this.initAppleBtn();
        });
      }
    },
  },
  mounted() {
    this.addScrollListener();
    this.addGoogleClickListener();
    if (this.visible) {
      this.$nextTick(() => {
        this.initGoogleBtn();
        this.initAppleBtn();
      });
    }
    trackLoginImpression("曝光", "底部浮窗栏");
  },
  beforeDestroy() {
    this.removeScrollListener();
    this.removeGoogleClickListener();
  },
};
